import { gql } from '@apollo/client';
/**
 * @const CheckAvailabilityQuery
 * @since 1.0.0
 */
export const CheckAvailabilityQuery = gql `
  query CheckAvailabilityQuery($input: CheckAvailabilityInput!) {
    checkAvailability(input: $input) {
      confirmedCount
      pendingCount
      totalCount
      confirmedDeals {
        id
        number
        title
      }
      pendingDeals {
        id
        number
        title
      }
    }
  }
`;
